import React from "react";
import Helmet from "react-helmet";
import { Jumbotron } from "../components/Jumbotron";
import SEO from "../components/SEO";
import { Link } from "gatsby";
import "../assets/css/App.css";
import "../assets/css/index.css";
import Layout from "../components/Layout";
import Contactform from "../components/ContactForm";
import { Jumbotronv2 } from "../components/Jumbotronv2";
import { RE } from "../components/Reviews";
import { ServicesBlock2 } from "../components/ServicesBlock2";


export default () => (
  <Layout>
    <SEO
      title="Commercial Boiler Repair"
      description="BBIS Heating conducts commercial boiler repairs all over London, Hertfordshire and the surrounding areas. Contact us today."
      keywords="central heating service london,central heating services london,london central heating services,boiler and central heating service
      ,boiler central heating service,central heating service providers,oil central heating service,central heating boiler service,gas central heating service,central
       heating service,central heating services,central heating systems london,gas central heating system installation,oil central heating system,gas central heating
        system,new central heating system,electric central heating systems,central heating system,,"
    />
    <Jumbotronv2 imgName="j18"  headingTag={"Commercial Boiler Repair"} descriptionTag={"Professional commercial heating repairs in London, Hertfordshire and the surrounding areas"}  showOverlay={true} />
    <div class="white-segment">
      <h2 class="heading-color">Get your heating and hot water restored to your commercial premises</h2>
      <p>Lost your heating or hot water? Boiler showing an error code? Whatever the problem, we understand how boiler problems can affect the smooth running of your business. </p>
      <p>Our team of Gas Safe engineers will always aim to get to you on the same day to repair your boiler to help reduce disruption for you, your staff and visitors.</p>
     </div>
     <div class="grey-segment">
      <h2 class="heading-color pb-2">Complete boiler breakdown service</h2>
      <p>Our engineers are fully qualified to work on all <Link to="/commercial-plant-room-installation-london/" ></Link>plant rooms and commercial gas, oil and LPG boilers, along with electric central heating systems. They’ll arrive promptly to diagnose your boiler fault and work with you to arrange a repair if required.</p>
      <br></br>
      <p>Our engineers can also repair:</p>
      <ul>
          <li>Air heaters and radiant tube heaters</li>
          <li>Pumps and valves</li>
          <li>Pressurisation units and pressure problems</li>
          <li>HVAC units</li>
          <li>Commercial catering equipment</li>
          <li>Heating controls</li>
          <li>Swimming pool boilers</li>
      </ul>
     </div>
     <div class="white-segment">
      <h2 class="heading-color pb-2">Why choose BBIS Commercial Heating?</h2>
      <ul>
        <li>Same or next working day repair service</li>
        <li>5-star ratings and reviews</li>
        <li>50 years of experience in domestic and commercial heating</li>
        <li>Friendly local commercial boiler engineers in London</li>
      </ul>
      <ServicesBlock2></ServicesBlock2>
    </div>
    <div class="grey-segment">
      <h3 class="heading-color pb-2">What our customers say</h3>
      <RE></RE>
    </div>
    <div className="white-segment">
      <h3 class="heading-color pb-2">We provide commercial heating services all over London, Hertfordshire and the surrounding areas</h3>
      <p>With over 50 years of experience in the domestic and commercial heating industry, get in contact today to find out how we can help.</p>
        <Contactform></Contactform>
      </div>
  </Layout>
);
